// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3NEA4","container":"styles_container__3lurN","title":"styles_title__3wI6B","wrapper":"styles_wrapper__a1Lh4","answer":"styles_answer__1YakV"};